<div class="mt-4">
    <router-outlet></router-outlet>
</div>
